import type { ConfirmationModalProps } from './types';
import { Button } from 'Components/shared/Button';
import { IconButton } from 'Components/shared/IconButton';
import React from 'react';
import { Styled } from './index.styles';

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onClose,
  onConfirm,
  textConfirm,
  textCancel,
  children,
  testid: parentTestId,
}) => (
  <Styled.Modal
    open={show}
    dimmer={{ blurring: true }}
    legacy={true}
    {...{ onClose }}
  >
    <Styled.Content>
      <Styled.TextContainer variant="h4">{children}</Styled.TextContainer>

      <Styled.ActionButtonsContainer>
        <Button
          onClick={onConfirm}
          variant="primary"
          content={textConfirm}
          testid={`${parentTestId}-buttonConfirm`}
        />

        <Styled.CancelButton
          onClick={onClose}
          variant="secondary"
          content={textCancel}
          testid={`${parentTestId}-buttonCancel`}
        />
      </Styled.ActionButtonsContainer>

      <Styled.CloseButtonContainer>
        <IconButton
          icon={'cancel'}
          onClick={onClose}
          size="small"
          testid={`${parentTestId}-buttonClose`}
        />
      </Styled.CloseButtonContainer>
    </Styled.Content>
  </Styled.Modal>
);
